import { fields } from "./filter-configs/fields.conf";

const filterInNodesWithFieldConfig = (formTree) => {
    return formTree.filter((node) => fields[node.properties.field]);
};

const enrichNodesWithFieldConfigAndIndex = (formTree) => {
    return formTree.map((node, index) => {
        const fieldConfig = fields[node.properties.field];
        return { node, index, config: fieldConfig };
    });
};

const categorizeNodes = (formTree) => {
    return formTree.reduce((categorizedNodes, node) => {
        const { config } = node;
        return !categorizedNodes[config.category]
            ? { ...categorizedNodes, [config.category]: [node] }
            : {
                  ...categorizedNodes,
                  [config.category]: [...categorizedNodes[config.category], node],
              };
    }, {});
};

export const formStateToCategorizedComponentData = (formTree) =>
    categorizeNodes(enrichNodesWithFieldConfigAndIndex(filterInNodesWithFieldConfig(formTree)));
